<template>
  <div class="container py-10">
    <transition name="fade" mode="out-in">
      <div v-if="submitted" class="text-center py-10">
        <h2>Your label order has been submitted</h2>
        <p class="mb-5">
          Thank you for your application. Following review of the information you submitted, someone will be in contact with you soon.
        </p>
        <div class="flex justify-center">
          <div class="pb-8 w-full md:w-8/12">
            <p class="text-lg font-bold mb-3">
              NEW AWI STANDARDS ALERT!
            </p>
            <p class="mb-2">
              If this project was BID after <strong><em>3/15/2019</em></strong>, unless otherwise specified, the new ANSI/AWI 0620 – 2018 Finish Carpentry/Installation Standards will apply for all Installation.
            </p>
            <p class="mb-2">
              If this project was BID after <strong><em>6/1/2020</em></strong>, unless otherwise specified, BOTH the new ANSI/AWI 0620 – 2018 Finish Carpentry/Installation Standards, AND, the new ANSI/AWI 0641-2019 Architectural Wood Casework Standards will apply for casework Fabrication and all Installation.
            </p>
            <div class="flex justify-center">
              <hr class="md:w-1/4">
            </div>
            <p class="mb-2">
              This will require review of <a href="https://www.awinet.org/standards/casework/introduction" target="_blank" rel="noopener noreferrer">casework</a> testing requirements.
            </p>
            <p class="mb-2">
              For further information, please see the referenced <a href="https://www.awinet.org/standards/standards-overview" target="_blank" rel="noopener noreferrer">Standards available on the AWI website.</a>
            </p>
          </div>
        </div>
        <d-btn href="https://awiqcp.org/" style="margin-top: 15px">
          Return Home
        </d-btn>
      </div>
      <div v-else class="flex flex-wrap -mx-5">
          <div class="w-full md:w-5/12 lg:w-4/12 px-5">
              <h1 class="font-bold text-primary-500 text-3xl">
                  Order Project Certification
              </h1>
              <p class="mb-5">
                  Before requesting project certificates or labels, your project must first be registered.
              </p>
              <p class="mb-5">
                  If your project has not been registered and assigned a six-digit project number (XX.XXXX), please<a href="/forms/register-project"> Register the Project.</a> After receiving your project number by email (usually 24 hours after completing the registration form) you may return and complete your transaction.
              </p>
              <p class="mb-5">
                  If your project has already been registered and you have the QCP-assigned six-digit project number, please complete the adjacent form, including payment of the project certification fee. If you prefer to complete a hard copy and pay by check, <a href="https://awiqcp.org/wp-content/uploads/2018/10/Project-Certificates-andor-Labels-Request-Form.pdf">click here</a> for a printable version to complete and mail with your check payment.
              </p>
              <p class="mb-5 font-bold">
                  Please note that only a woodworking firm with active QCP licenses for the categories of work required for your project may provide certification.
              </p>
              <p class="mb-5 font-bold">
                  For your information security, if you leave or refresh this page prior to submitting the form, your entry will be cleared and you will have to fill the form out again.
              </p>
          </div>
        <div class="w-full md:w-7/12 lg:w-8/12 px-5 pb-10">
          <transition name="fade" mode="out-in">
            <page-one v-if="currentPage == 1" />
            <page-two v-if="currentPage == 2" />
            <page-three v-if="currentPage == 3" />
            <page-four v-if="currentPage == 4" />
            <page-five v-if="currentPage == 5" />
            <page-six v-if="currentPage == 6" />
            <page-seven v-if="currentPage == 7" />
            <page-eight v-if="currentPage == 8" />
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_CERTIFICATION_FORM } from '@resources/scripts/store/mutation-types';
  import PageOne from './components/ProjectCertification/PageOne.vue';
  import PageTwo from './components/ProjectCertification/PageTwo.vue';
  import PageThree from './components/ProjectCertification/PageThree.vue';
  import PageFour from './components/ProjectCertification/PageFour.vue';
  import PageFive from './components/ProjectCertification/PageFive.vue';
  import PageSix from './components/ProjectCertification/PageSix.vue';
  import PageSeven from './components/ProjectCertification/PageSeven.vue';
  import PageEight from './components/ProjectCertification/PageEight.vue';

  const { mapGetters, mapActions } = createNamespacedHelpers('projectCertificationForm');

  export default {
    parent: true,
    components: {
      PageOne,
      PageTwo,
      PageThree,
      PageFour,
      PageFive,
      PageSix,
      PageSeven,
      PageEight,
    },

    props: {
      minPrice: Number,
      maxPrice: Number,
      existingOrder: {
        type: Object,
        default: null,
      },
    },

    computed: {
      ...mapFields({
        fields: ['transactionMinPrice', 'transactionMaxPrice'],
        module: 'projectCertificationForm',
        base: 'formFields',
        mutation: PROJECT_CERTIFICATION_FORM.FORM_FIELDS,
      }),

      ...mapGetters([
        'currentPage',
        'submitted',
      ]),
    },

    mounted() {
      if (this.existingOrder) {
        this.existingInfoFieldUpdate(this.existingOrder);
      }
      this.getCountries();
      this.transactionMinPrice = this.minPrice;
      this.transactionMaxPrice = this.maxPrice;
    },

    methods: {
      ...mapActions([
        'existingInfoFieldUpdate',
        'getCountries',
      ]),
    },
  };
</script>